"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAndroidFn = exports.removeBase64Prefix = void 0; // 去除图片中base64字符串的前面标识部分，原生保存图片不需要使用到

function removeBase64Prefix(base64Str) {
  if (!base64Str) return '';
  return base64Str.replace(/^data:image\/\w*;base64,/i, '');
}

exports.removeBase64Prefix = removeBase64Prefix;

function isAndroidFn() {
  var _a, _b; // 多层判断，防止非浏览器环境报错


  if (typeof window !== 'object') return false;
  var u = (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : '';
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

exports.isAndroidFn = isAndroidFn;